import { FC } from "react"
import { useNavigate } from "react-router-dom"
import { DevicesTable } from "@/components/DevicesTable"
import useGetRecentDevicesWithLeaks from "@/hooks/api/use-get-recent-devices-with-leaks"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"

interface RecentDevicesWithLeaksProps {
  councilId: string
}

export const RecentDevicesWithLeaks: FC<RecentDevicesWithLeaksProps> = ({ councilId }) => {
  const navigate = useNavigate()
  const { data: recentDevices, isLoading, error } = useGetRecentDevicesWithLeaks(Number(councilId))

  // Transform the API data to match the DevicesTable interface
  const devices =
    recentDevices?.map((device) => ({
      id: device.name || "",
      name: device.name || "",
      serialNumber: device.serialNumber || "",
      type: device.type || null,
      leakAlarms: device.alarmCount || 0,
      lastUpdated: device.lastUpdated || "",
      customerId: "",
      customerName: "",
    })) || []

  if (isLoading) {
    return (
      <Card className="w-full">
        <CardHeader className="pb-2">
          <CardTitle className="text-lg">Recent Devices with Leaks</CardTitle>
          <p className="text-sm text-muted-foreground">Devices currently reporting leak alerts</p>
        </CardHeader>
        <CardContent>
          <div className="max-h-96 overflow-auto">
            <div className="flex items-center justify-center h-32">
              <div className="text-sm text-muted-foreground">Loading...</div>
            </div>
          </div>
        </CardContent>
      </Card>
    )
  }

  if (error) {
    return (
      <Card className="w-full">
        <CardHeader className="pb-2">
          <CardTitle className="text-lg">Recent Devices with Leaks</CardTitle>
          <p className="text-sm text-muted-foreground">Devices currently reporting leak alerts</p>
        </CardHeader>
        <CardContent>
          <div className="max-h-96 overflow-auto">
            <div className="flex items-center justify-center h-32">
              <div className="text-sm text-muted-foreground">Failed to load devices</div>
            </div>
          </div>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card className="w-full">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Recent Devices with Leaks</CardTitle>
        <p className="text-sm text-muted-foreground">Devices currently reporting leak alerts</p>
      </CardHeader>
      <CardContent>
        <div className="max-h-96 overflow-auto">
          <DevicesTable
            devices={devices}
            compact
            onDeviceClick={(deviceId) => navigate(`/council/${councilId}/devices/${deviceId}`)}
          />
        </div>
      </CardContent>
    </Card>
  )
}
